import React from 'react';

export default function DoorArrowIconOutlined() {
    return (
        <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M16 7.15385V4C16 3.44772 15.5523 3 15 3H5C4.44772 3 4 3.44772 4 4V20C4 20.5523 4.44772 21 5 21H15C15.5523 21 16 20.5523 16 20V16.8462"
                stroke="#2196F3"
                strokeWidth="2"
            />
            <path
                d="M10 12.1538H14.9616H20.9231M20.9231 12.1538L17.7693 9M20.9231 12.1538L17.7693 15.3077"
                stroke="#2196F3"
                strokeWidth="2"
            />
        </svg>
    );
}
